import {observer} from "mobx-react";
import React from "react";

import {WidgetConfigurationProps} from "controls/designer/features/widgets/widgetConfig";
import {Section} from 'controls/react/layout/section'
import {FormEntryNew} from "controls/react/form/formEntryNew";
import {AntInput} from "controls/react/ant/antInput";
import { i18n } from "core/localization";
import {IncidentsGridWidgetConfig} from "areas/incidents/widgets/IncidentsGridWidget/config";
import {AccountsSelector} from "controls/react/accountSelector";
import {AntCheckbox} from "controls/react/ant/antCheckbox";
import {TagsSelect} from "controls/react/tagsSelect";

export const Editor = observer((props: WidgetConfigurationProps<IncidentsGridWidgetConfig>) => {
	return <Section appearance={"none"}
	                contentPadding={false}
	                childrenPadding={true}>
		<Section title={i18n('General')} appearance={"frame-top-only"}>
			<FormEntryNew label={i18n('Title')} model={props.config} modelField={"title"}>
				<AntInput/>
			</FormEntryNew>
		</Section>
		<Section title={i18n('Data')} appearance={"frame-top-only"} margin={"bottom"}>
			<FormEntryNew label={i18n('Accounts')} model={props.config} modelField={"accountIds"}>
				<AccountsSelector/>
			</FormEntryNew>
			<FormEntryNew model={props.config} modelField={"includeSubaccounts"}>
				<AntCheckbox>{i18n('Include subaccounts')}</AntCheckbox>
			</FormEntryNew>
			<FormEntryNew label={i18n('Tags')} model={props.config} modelField={"tags"}>
				<TagsSelect/>
			</FormEntryNew>
		</Section>
	</Section>
})
